module.exports = __webpack_public_path__ + "static/media/pdf-icon.9fd390c4.svg";